import { Action } from '@/_core/fluxstore/types';
import { StorymapState, defaultFilters } from '../types';
import { useStorymapStore } from '../useModule';
import cloneDeep from 'lodash/cloneDeep';

const { registerReducer } = useStorymapStore();

export class ResetStorymap extends Action<StorymapState> {
    public static ACTION_TYPE = 'ResetStorymap';

    public constructor() {
        super(ResetStorymap.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: ResetStorymap): void => {
    state.isInitialized = false;
    state.isAiStorymapLoading = false;
    state.aiCreateStoryMapErrorMessage = '';

    state.name = '';
    state.releases = [];
    state.activities = [];
    state.tasks = [];
    state.subtasks = [];

    state.correlationId = '';
    state.id = '';
    state.slug = '';
    state.productSlug = '';
    state.isPublishedRecipient = false;
    state.publishedAccessKind = null;
    state.publishedAccessKey = '';
    state.canComment = false;
    state.aiDataDialogState.isAiDataDialogOpen = false;

    state.filterState = cloneDeep(defaultFilters);

    state.trackingViewState = {
        releaseId: null,
        filterTaskIds: [],
        filterActivityIds: [],
        hoveredCardId: null,
    };

    state.shouldOpenIntegrationTokenExpiredDialog = false;

    document.title = 'StoriesOnBoard';
};

//@ts-ignore
registerReducer(ResetStorymap.ACTION_TYPE, reducer);
